import { useIllustrationColor } from '../hooks/useIllustrationColor.hook';
import type { IllustrationProps } from '../types/props.type';

// https://undraw.co/search/add-post
export const AddPostIllustration = ({
  color: pColor,
  title = 'Informations indisponibles ...',
}: Readonly<IllustrationProps>) => {
  const color = useIllustrationColor(pColor);

  return (
    <svg
      height="603.69"
      role="img"
      viewBox="0 0 947.25 603.69"
      width="947.25"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>{title}</title>
      <path
        d="M452.65527,713.275l-29,16.84,28.58985-6.9c-.22022,2.36-.52,4.68-.91992,6.95-.11036.63-.23,1.25-.36036,1.87a51.87781,51.87781,0,0,1-5.25,14.92005c-.48.86-.96,1.69995-1.46,2.51-.48.82-.98,1.61-1.48974,2.38H365.895c-.64014-.77-1.25-1.57-1.81006-2.38a35.97564,35.97564,0,0,1-6.17969-26.62,44.96785,44.96785,0,0,1,1.19971-5.63,51.56839,51.56839,0,0,1,1.83008-5.57,73.442,73.442,0,0,1,4.41015-9.35c3.52-6.34,9.00977-12.06,15.48-17.14a108.06933,108.06933,0,0,1,9.77978-6.8q.96021-.615,1.9502-1.2c1.00976-.6,2.02-1.19,3.04-1.76,2.02979-1.16,4.07959-2.26,6.12989-3.3.54-.28,1.06982-.55,1.6001-.81,4.4497-2.22,8.87988-4.21,13.0996-5.96.53028-.22,1.07032-.44,1.6001-.65a233.30757,233.30757,0,0,1,25.72022-8.81s.02978.08.08008.25c.12988.46.46,1.57.90966,3.21,1.25,4.55,3.4502,13.23,5.22022,23.71.1001.57.18994,1.15.29,1.73005a181.68776,181.68776,0,0,1,2.4497,26.81c.01026.56.01026,1.11.01026,1.67Z"
        fill="#f2f2f2"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M445.86523,654.845c-.01025.03-.11035.52-.34033,1.42-.18994.75-.4497,1.78-.79,3.06-1.16992,4.47-3.25,11.96-6.21,20.98-.16992.52-.3501,1.06-.52978,1.6-2.06006,6.17-4.51026,12.99-7.33985,20-.71045,1.76-1.42041,3.49-2.15039,5.18-.21972.53-.43994,1.05005-.66992,1.56q-4.65015,10.77007-9.56982,19.71l-.83008,1.49a134.52429,134.52429,0,0,1-13.18994,19.62c-.66992.82-1.3501,1.61-2.04,2.38h-2.32031c.70019-.77,1.40039-1.57,2.08007-2.38a132.14581,132.14581,0,0,0,13.87012-20.4c.28027-.49.56006-.98.83008-1.48,3.52978-6.41,6.74023-13.11,9.60986-19.75.23-.51.4502-1.03.66992-1.56,3.75-8.78,6.90039-17.41,9.44-25.00994.18017-.54.36035-1.08.53027-1.61005,3.70019-11.22,6.02-20.02,6.91016-23.54.11962-.52.21972-.93.29-1.21.06983-.26.09961-.41.10987-.44l.81006.19h.00976Z"
        fill="#fff"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M451.48486,683.165c-.50976-.03-1.02-.08-1.52978-.13a44.99648,44.99648,0,0,1-11.43018-2.73c-.52978-.21-1.06982-.42-1.60986-.65a45.858,45.858,0,0,1-4.28027-2.11,45.27611,45.27611,0,0,1-14.60987-12.87c-.12988-.17-.25976-.35-.37988-.52q-.78.33-1.58984.66c.11962.17.23974.34.36962.51a46.76551,46.76551,0,0,0,15.39014,13.7,48.307,48.307,0,0,0,4.56983,2.24006c.53027.22,1.07031.44,1.61035.63995a46.89079,46.89079,0,0,0,12.25,2.86005c.5.05,1.00976.09,1.50976.12C451.665,684.295,451.5752,683.725,451.48486,683.165Z"
        fill="#fff"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M452.69482,711.575a45.37037,45.37037,0,0,1-24.18994-4.49q-.79467-.375-1.56006-.81a4.2326,4.2326,0,0,1-.46972-.25,45.58023,45.58023,0,0,1-23.1499-34.74c-.02-.17-.04-.35-.06006-.51995-.54.28-1.08008.55-1.60987.83.01953.17.03955.33.06983.5a47.22571,47.22571,0,0,0,23.93017,35.41c.19971.11.40967.23.61963.32995q.78.42,1.56006.81a47.05043,47.05043,0,0,0,24.82031,4.63c.44971-.04.89991-.09,1.34961-.13995,0-.57.01026-1.13.01026-1.7C453.5752,711.485,453.13477,711.535,452.69482,711.575Z"
        fill="#fff"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M451.3252,730.165a45.54776,45.54776,0,0,1-27.75.21,44.468,44.468,0,0,1-5.31006-2.02c-.54-.24-1.07032-.5-1.6001-.77-.56983-.28-1.12988-.57995-1.68018-.87994a45.67468,45.67468,0,0,1-23.38965-42.39,43.76337,43.76337,0,0,1,.96-7.16c.02978-.16.06-.32.10009-.48-.66015.41-1.32031.82-1.97021,1.24-.02979.15-.06006.29-.08008.44a46.77057,46.77057,0,0,0-.73,9.79,47.25281,47.25281,0,0,0,24.28027,40.03c.55957.31,1.11963.61,1.67969.89.53027.27,1.07031.53,1.6001.78a47.17478,47.17478,0,0,0,33.52978,2.19c.37012-.1.74024-.22,1.11036-.34.1499-.64.27978-1.28.3999-1.92C452.09521,729.915,451.71484,730.045,451.3252,730.165Z"
        fill="#fff"
        transform="translate(-126.375 -148.155)"
      />
      <rect fill="#9e616a" height="56" width="56" x="200.25" y="246.52002" />
      <polygon
        fill="#9e616a"
        points="165.326 581.214 176.36 581.213 181.608 538.656 165.324 538.657 165.326 581.214"
      />
      <path
        d="M321.98486,741.805l-16.57959-11.45v-7.47l-1.88037.11-11.81982.71-3.74024.22-2.12988,25.54-.06982.85h7.83007l.15967-.85,1.24024-6.54,3.16992,6.54.41016.85H319.335a4.67905,4.67905,0,0,0,4.66992-4.66A4.67076,4.67076,0,0,0,321.98486,741.805Z"
        fill="#2f2e41"
        transform="translate(-126.375 -148.155)"
      />
      <polygon
        fill="#9e616a"
        points="229.853 574.209 240.457 577.258 257.265 537.81 241.615 533.309 229.853 574.209"
      />
      <path
        d="M381.895,742.695l-12.77-15.59,2.06982-7.18-1.83984-.41-10.25-2.3-1.31006-.29-3.6499-.82-9.41016,24.75,7.52,2.17,3.39014-6.72,1.39014,8.09,4.73974,1.36005,12.89014,3.71,2.33008.67a4.66278,4.66278,0,0,0,4.8999-7.44Z"
        fill="#2f2e41"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M1070.355,148.155H485.895a3.28,3.28,0,0,0-3.27,3.28v19.25a3.27992,3.27992,0,0,0,3.27,3.28h584.46a3.27961,3.27961,0,0,0,3.27-3.28v-19.25A3.27966,3.27966,0,0,0,1070.355,148.155Z"
        fill="#e4e4e4"
        transform="translate(-126.375 -148.155)"
      />
      <circle
        cx="375.2487"
        cy="11.96482"
        data-name="Ellipse 90"
        fill="#fff"
        id="b5b16cf8-67a2-4f26-b1bf-3e43b6764a92"
        r="4.64784"
      />
      <circle
        cx="392.89038"
        cy="11.96482"
        data-name="Ellipse 91"
        fill="#fff"
        id="b66c556c-a3ce-485d-a169-682ae89102b6"
        r="4.64784"
      />
      <circle
        cx="410.53288"
        cy="11.96482"
        data-name="Ellipse 92"
        fill="#fff"
        id="b9ccba63-6bb8-47f6-85e8-d2b1a1d873e2"
        r="4.64784"
      />
      <path
        d="M1053.06494,153.915h-20.31006a1.505,1.505,0,1,0,0,3.01h20.31006a1.505,1.505,0,1,0,0-3.01Z"
        fill="#fff"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M1053.06494,159.555h-20.31006a1.505,1.505,0,1,0,0,3.01h20.31006a1.505,1.505,0,1,0,0-3.01Z"
        fill="#fff"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M1053.06494,165.195h-20.31006a1.505,1.505,0,1,0,0,3.01h20.31006a1.505,1.505,0,1,0,0-3.01Z"
        fill="#fff"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M1050.75488,229.645H899.3252a3.99016,3.99016,0,0,0-3.98,3.98v61.45a3.9901,3.9901,0,0,0,3.98,3.98h151.42968a3.9838,3.9838,0,0,0,3.98-3.98v-61.45A3.98385,3.98385,0,0,0,1050.75488,229.645Z"
        fill="#e4e4e4"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M1036.335,318.975H913.74512a4.775,4.775,0,0,0,0,9.55H1036.335C1042.55518,328.615,1042.49512,318.885,1036.335,318.975Z"
        fill="#e4e4e4"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M1036.335,340.865H913.74512a4.775,4.775,0,0,0,0,9.55H1036.335C1042.55518,350.505,1042.49512,340.775,1036.335,340.865Z"
        fill="#e4e4e4"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M1036.335,362.755H913.74512a4.775,4.775,0,0,0,0,9.55H1036.335C1042.55518,372.395,1042.49512,362.665,1036.335,362.755Z"
        fill="#e4e4e4"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M851.75488,229.645H700.3252a3.99016,3.99016,0,0,0-3.98,3.98v61.45a3.9901,3.9901,0,0,0,3.98,3.98H851.75488a3.9838,3.9838,0,0,0,3.98-3.98v-61.45A3.98385,3.98385,0,0,0,851.75488,229.645Z"
        fill="#e4e4e4"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M837.335,318.975H714.74512a4.775,4.775,0,0,0,0,9.55H837.335C843.55518,328.615,843.49512,318.885,837.335,318.975Z"
        fill="#e4e4e4"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M837.335,340.865H714.74512a4.775,4.775,0,0,0,0,9.55H837.335C843.55518,350.505,843.49512,340.775,837.335,340.865Z"
        fill="#e4e4e4"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M837.335,362.755H714.74512a4.775,4.775,0,0,0,0,9.55H837.335C843.55518,372.395,843.49512,362.665,837.335,362.755Z"
        fill="#e4e4e4"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M472.04287,345.86227a10.02421,10.02421,0,0,0-.42317,1.74747l-62.00428-10.95961-53.4076-28.7994a15.08,15.08,0,0,0-16.0966,25.41817l.00006,0A118.971,118.971,0,0,0,372.847,350.26435l38.71983,12.96946,67.82117-4.34723a9.9971,9.9971,0,1,0-7.34512-13.02431Z"
        fill="#9e616a"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M624.55518,346.055h-193.02a5.08706,5.08706,0,0,0-5.08008,5.08v78.31a5.087,5.087,0,0,0,5.08008,5.07995h193.02A5.08488,5.08488,0,0,0,629.625,429.445v-78.31A5.0849,5.0849,0,0,0,624.55518,346.055Z"
        fill={color}
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M606.1748,459.915H449.915a6.09,6.09,0,0,0,0,12.18H606.1748C614.105,472.20505,614.0249,459.805,606.1748,459.915Z"
        fill={color}
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M606.1748,487.815H449.915a6.09,6.09,0,0,0,0,12.18H606.1748C614.105,500.105,614.0249,487.70505,606.1748,487.815Z"
        fill={color}
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M606.1748,515.725H449.915a6.085,6.085,0,1,0,0,12.17H606.1748C614.105,528.005,614.0249,515.615,606.1748,515.725Z"
        fill={color}
        transform="translate(-126.375 -148.155)"
      />
      <circle
        cx="357.65385"
        cy="265.79258"
        fill="#9e616a"
        r="29.72868"
        transform="translate(-173.49417 303.97269) rotate(-61.33683)"
      />
      <path
        d="M362.625,229.675H343.4209c-12.58985,0-22.7959,11.48193-22.7959,25.64563-9.5,9.53894-6.64893,21.48919.88867,34.35437a149.22541,149.22541,0,0,1,39.541,10.57574l1.79248-7.65448,3.53564,10.08081q4.71679,2.28534,9.35352,4.99793c-3.60791-16.95111-5.09278-33.86286-2.61572-47H379.625v-7.1181l2.208,7.1181h11.792V260.675A30.9998,30.9998,0,0,0,362.625,229.675Z"
        fill="#2f2e41"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M360.625,303.675,324.66978,302.116l-.967,3.67373a213.66873,213.66873,0,0,0-3.59909,92.56989l0,0h0a8.24249,8.24249,0,0,1,2.34458,8.00651l-.5165,2.0591.04779.07542a12.06182,12.06182,0,0,1,1.60133,9.00482v0l1.79834,9.90181L383.625,401.675l13-45Z"
        fill="#cacaca"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M449.73154,398.51889a10.024,10.024,0,0,0-1.08438,1.43417L396.1439,365.196l-37.51032-47.69436a15.08,15.08,0,0,0-24.89132,16.89988l0,0a118.97085,118.97085,0,0,0,23.25336,28.63132l30.34607,27.323,63.93732,23.03539a9.9971,9.9971,0,1,0-1.54751-14.87242Z"
        fill="#9e616a"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M563.90846,298.81988a28.73541,28.73541,0,1,1,28.73541-28.73541A28.73543,28.73543,0,0,1,563.90846,298.81988Z"
        fill="#e4e4e4"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M575.24669,267.25h-8.50362v-8.50373a2.83461,2.83461,0,0,0-5.66922,0V267.25h-8.50374a2.83457,2.83457,0,0,0,0,5.66913h8.50374v8.50372a2.83461,2.83461,0,0,0,5.66922,0v-8.50372h8.50362a2.83457,2.83457,0,1,0,0-5.66913Z"
        fill="#fff"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M420.61426,619.61374a16.87393,16.87393,0,0,0-1.57031-15.08753L393.625,472.675l-10-50h-60s-37.5,41.5-29.5,94.5l-2.23926,74.64014a27.44788,27.44788,0,0,0-1.50342,16.18585l.89112,4.22223-.34375.63592a21.33414,21.33414,0,0,0-.26856,19.77216L288.125,717.175l18-1,26.5-98.5,17.5-88.5,29.5,68.5,1,16-.48535,14.10333L357.125,710.175l19.5,7.5Z"
        fill="#2f2e41"
        transform="translate(-126.375 -148.155)"
      />
      <path
        d="M566.05518,750.655a1.193,1.193,0,0,1-1.18995,1.19H127.56494a1.19,1.19,0,0,1,0-2.38H564.86523A1.18664,1.18664,0,0,1,566.05518,750.655Z"
        fill="#cacaca"
        transform="translate(-126.375 -148.155)"
      />
    </svg>
  );
};
